import SpreadGuidance from "./SpreadGuidance";
import YieldGuidance from "./YieldGuidance";
import PriceGuidance from "./PriceGuidance";
import CouponGuidance from "./CouponGuidance";
class Guidance {
    price;
    spread;
    yield;
    coupon;
    constructor(response) {
        this.price = response.price !== undefined ? new PriceGuidance(response.price) : undefined;
        this.spread = response.spread !== undefined ? new SpreadGuidance(response.spread) : undefined;
        this.yield = response.yield !== undefined ? new YieldGuidance(response.yield) : undefined;
        this.coupon = response.coupon !== undefined ? new CouponGuidance(response.coupon) : undefined;
    }
    basis() {
        if (this.spread !== undefined)
            return 'spread';
        if (this.yield !== undefined)
            return 'yield';
        if (this.price !== undefined && this.coupon !== undefined)
            return 'priceCoupon';
        if (this.price !== undefined)
            return 'price';
        if (this.coupon !== undefined)
            return 'coupon';
        return undefined;
    }
    benchmark() {
        return this.spread?.benchmark;
    }
    print() {
        if (this.spread !== undefined) {
            return this.spread.print();
        }
        if (this.price !== undefined || this.coupon !== undefined) {
            const items = [];
            if (this.coupon !== undefined) {
                items.push(this.coupon.print());
            }
            if (this.price !== undefined) {
                items.push(this.price.print());
            }
            return items.join(" / ");
        }
        if (this.yield !== undefined) {
            return this.yield.print();
        }
        return undefined;
    }
}
export default Guidance;
